import { motion } from "framer-motion";
import { useI18n } from "../lib/i18n";

const NODES = [
  { x: 96, y: 150, label: "North America" },
  { x: 128, y: 236, label: "South America" },
  { x: 196, y: 128, label: "Europe" },
  { x: 210, y: 210, label: "Africa" },
  { x: 276, y: 146, label: "Asia" },
  { x: 302, y: 252, label: "Oceania" },
];

export default function NetworkMap() {
  const { d } = useI18n();
  const n = d.network;

  return (
    <div className="grid items-center gap-12 lg:grid-cols-2">
      <div className="relative" data-testid="network-globe">
        <svg viewBox="0 0 400 400" className="mx-auto w-full max-w-md text-foreground/25">
          <defs>
            <clipPath id="globe-clip">
              <circle cx="200" cy="200" r="168" />
            </clipPath>
          </defs>
          <circle cx="200" cy="200" r="168" fill="none" stroke="currentColor" strokeWidth="1" />
          <g clipPath="url(#globe-clip)" fill="none" stroke="currentColor" strokeWidth="0.7">
            <ellipse cx="200" cy="200" rx="168" ry="168" />
            <ellipse cx="200" cy="200" rx="120" ry="168" />
            <ellipse cx="200" cy="200" rx="62" ry="168" />
            <line x1="32" y1="200" x2="368" y2="200" />
            <ellipse cx="200" cy="200" rx="168" ry="120" />
            <ellipse cx="200" cy="200" rx="168" ry="62" />
          </g>
          <path d="M 96 150 Q 146 90 196 128" fill="none" stroke="#9B1138" strokeWidth="1" strokeDasharray="3 6" opacity="0.6">
            <animate attributeName="stroke-dashoffset" from="36" to="0" dur="3s" repeatCount="indefinite" />
          </path>
          <path d="M 196 128 Q 236 100 276 146" fill="none" stroke="#9B1138" strokeWidth="1" strokeDasharray="3 6" opacity="0.6">
            <animate attributeName="stroke-dashoffset" from="36" to="0" dur="3.6s" repeatCount="indefinite" />
          </path>
          <path d="M 276 146 Q 300 200 302 252" fill="none" stroke="#9B1138" strokeWidth="1" strokeDasharray="3 6" opacity="0.6">
            <animate attributeName="stroke-dashoffset" from="36" to="0" dur="4.2s" repeatCount="indefinite" />
          </path>
          {NODES.map((node, i) => (
            <g key={node.label}>
              <motion.circle
                cx={node.x}
                cy={node.y}
                r="3"
                fill="#9B1138"
                animate={{ opacity: [1, 0.35, 1] }}
                transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.4 }}
              />
              <motion.circle
                cx={node.x}
                cy={node.y}
                fill="none"
                stroke="#9B1138"
                strokeWidth="1"
                initial={{ r: 3, opacity: 0.7 }}
                animate={{ r: 14, opacity: 0 }}
                transition={{ duration: 2.4, repeat: Infinity, delay: i * 0.4, ease: "easeOut" }}
              />
            </g>
          ))}
        </svg>
        <p className="mt-4 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          {n.globeNote}
        </p>
      </div>

      <div>
        <div className="corner-ticks border border-border bg-card/60 p-2">
          {n.regions.map((name, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-center justify-between gap-4 border-b border-border px-5 py-4 last:border-0"
              data-testid={`region-row-${i}`}
            >
              <div>
                <p className="text-sm font-medium">{name}</p>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{n.chapterNote}</p>
              </div>
              <span className="whitespace-nowrap border border-gold/50 px-2.5 py-1 font-mono text-[9px] uppercase tracking-[0.15em] text-gold">
                {n.regionStatus}
              </span>
            </motion.div>
          ))}
        </div>
        <p className="mt-4 text-xs leading-relaxed text-muted-foreground">{n.regionsNote}</p>
      </div>
    </div>
  );
}
